"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loading = require("./Loading");

Object.keys(_Loading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Loading[key];
    }
  });
});